// extracted by mini-css-extract-plugin
export var label = "_gv-2";
export var slideContainer = "_gv-0";
export var slider = "_gv-1";